import { render, staticRenderFns } from "./LinkTagView.vue?vue&type=template&id=06147476&scoped=true&"
import script from "./LinkTagView.vue?vue&type=script&lang=js&"
export * from "./LinkTagView.vue?vue&type=script&lang=js&"
import style0 from "./LinkTagView.vue?vue&type=style&index=0&id=06147476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06147476",
  null
  
)

export default component.exports